import { render, staticRenderFns } from "./claim_apply.vue?vue&type=template&id=6a264d05&scoped=true&"
import script from "./claim_apply.vue?vue&type=script&lang=js&"
export * from "./claim_apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a264d05",
  null
  
)

export default component.exports